import includes from 'lodash/includes';
import intersection from 'lodash/intersection';
import isArray from 'lodash/isArray';
import trim from 'lodash/trim';

import {
  AddressComponentItemType,
  AddressFormattedType,
  AddressType,
} from './types';

export const extractAddressComponents = (
  components: AddressComponentItemType[],
  type: string | string[],
  key: 'long_name' | 'short_name' = 'long_name'
): string | null => {
  const targetKey = includes(['short_name', 'long_name'], key);
  if (!targetKey) return null;
  return (
    components
      .filter((component) => {
        if (isArray(type)) {
          return intersection(component.types, type).length > 0;
        }
        return component.types.indexOf(type) === 0;
      })
      .map((item) => item[key])
      .pop() || null
  );
};

export const isCommaAtEnd = (text = '') => {
  const trimText = trim(text);
  return trimText.slice(-1) === ',';
};

export const addCommaToEnd = (text?: string, comma = true) => {
  if (!text) return '';
  const trimText = trim(text);
  const hasComma = isCommaAtEnd(trimText);
  return `${trimText}${comma && !hasComma ? ',' : ''}`;
};

export const formatAddress = (data: AddressType): AddressFormattedType => {
  const addressOne = addCommaToEnd(data.addressOne);
  const addressTwo = addCommaToEnd(data.addressTwo);
  const postalCode = addCommaToEnd(data.postalCode, false);
  const city = addCommaToEnd(data.city);
  const state = addCommaToEnd(data.state);
  const country = addCommaToEnd(data.country, false);

  return {
    formatted: `${addressOne} ${addressTwo} ${postalCode} ${city} ${state} ${country}`,
    address: {
      addressOne,
      addressTwo,
      postalCode,
      city,
      state,
      country,
    },
  };
};

export default {
  formatAddress,
  extractAddressComponents,
};
